import { fetchData, apiURL } from './api_helper';

const create = payload => new Promise(((resolve, reject) => {
    const endpointURL = `${apiURL}companies/${payload.companyId}/users/${payload.userId}/kudos`;
    fetchData(endpointURL, 'post', payload.kudo).then((result) => {
        resolve(result);
    }).catch((error) => {
        reject(error);
    });
}));

const thank = code => new Promise(((resolve, reject) => {
    const endpointURL = `${apiURL}kudos/${code}`;
    fetchData(endpointURL, 'post', {}).then((result) => {
        resolve(result);
    }).catch((error) => {
        reject(error);
    });
}));

export default {
    create,
    thank,
};
